import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, lifecycle, getContext } from 'recompose';
import { IconButton } from 'material-ui';
import WarningIcon from 'material-ui/svg-icons/alert/warning';
import { deepOrange500 } from 'material-ui/styles/colors';
import _ from 'lodash';
import { STORE_KEYS } from 'dash-front/constants';
import { getEntities } from 'dash-front/selectors';
import { fetchSmlinks } from 'dash-front/campaign/actions/smlinks';
import cfg from 'cfg';

const SMLINK_BY_ID = STORE_KEYS.SMLINKS + STORE_KEYS.BY_ID;

const onEditSmlink = (smlink, userId) => {
    const { smtype, _id: smlinkId } = smlink;
    const { smpg } = cfg.apis;
    if (smtype === 'fb') {
        const url = `${smpg}/facebook/update?id=${smlinkId}&client=${userId}&service=any`;
        window.open(url, 'Update', 'height=500,width=700');
    } else if (smtype === 'tw') {
        const url = `${smpg}/twitter/update?id=${smlinkId}&client=${userId}&service=any`;
        window.open(url, 'Update', 'height=500,width=700');
    }
};

const SMLinkTitle = ({ smlink, user, style, onClick }) => {
    const value = _.get(smlink, 'title');
    const invalid = _.get(smlink, 'invalid');
    const hasOnClick = onClick instanceof Function;
    const handleClick = () => {
        if (hasOnClick) {
            onClick(smlink);
        }
    };
    return (
        <span
            style={{
                display: 'flex',
                alignItems: 'center',
                cursor: hasOnClick ? 'pointer' : 'initial',
                ...style
            }}
            onClick={handleClick}
        >
            {value}{' '}
            {invalid && (
                <IconButton
                    tooltip={'Click to fix the issue with your account'}
                    onTouchTap={() => onEditSmlink(smlink, user._id)}
                >
                    <WarningIcon color={deepOrange500} style={{ marginLeft: 8 }} />
                </IconButton>
            )}
        </span>
    );
};

export default compose(
    getContext({
        user: PropTypes.object
    }),
    connect(
        (state, { id }) => ({
            smlink: _.get(getEntities(state)[SMLINK_BY_ID], id)
        }),
        dispatch => ({
            updateSmlinks: () => dispatch(fetchSmlinks())
        })
    ),
    lifecycle({
        componentDidMount() {
            const onMessageReceived = message => {
                if (message.origin === cfg.apis.smpg) {
                    this.props.updateSmlinks();
                }
            };
            if (!this.props.smlink) {
                this.props.updateSmlinks();
            }
            addEventListener('message', onMessageReceived, false);
        }
    })
)(SMLinkTitle);



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/SMLink/SMLinkTitle.js
 **/